import React from 'react';

export const NewsArticleText = (props) => {
  return <div className="__news-article-text" {...props} />;
};
